import {createSvgIcon} from '../create-svg-icon';

export const KeyboardReturnIcon = createSvgIcon(
  <path d="M19 7v4H5.83l3.58-3.59L8 6l-6 6 6 6 1.41-1.41L5.83 13H21V7h-2z" />
, 'KeyboardReturnOutlined');
